import { BankType, BrandType, Country } from '../../../generated/graphql';
import { generalBeta } from '../../beta/dictionaries';
import { generalJcap } from '../../jcap/dictionaries';
import { generalApex } from '../../apex/dictionaries';
import { generalPra } from '../../pra/dictionaries';
import {
  bbva,
  bogota,
  claro,
  daviplata,
  davivienda,
  luloBank,
  pichincha,
  rappipay,
  rappiPrestamo,
  scotiabank,
} from '../../tranquifinanzas/dictionaries';
import general from './general.json';

interface Dictionary {
  [key: string]: string | { [key: string]: string }
}

export interface DictionariesType {
  name: string;
  dictionaries: Dictionary[];
}

const dictionaries: DictionariesType[] = [
  { name: '', dictionaries: [ general ] },
  { name: BrandType.Tranquiapp, dictionaries: [ general ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}`, dictionaries: [ general ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.BancoDavivienda}`, dictionaries: [ davivienda, { welcome: 'tranqui co dav blah' } ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.Bbva}`, dictionaries: [ general, bbva ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-DAVIPLATA`, dictionaries: [ daviplata ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.LuloBank}`, dictionaries: [ luloBank ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.Pichincha}`, dictionaries: [ pichincha ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.Rappipay}`, dictionaries: [ rappipay ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.RappiPrestamo}`, dictionaries: [ rappiPrestamo ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.BancoDeBogota}`, dictionaries: [ bogota ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.Scotiabank}`, dictionaries: [ scotiabank ] },
  { name: `${BrandType.Tranquiapp}-${Country.Co}-${BankType.Claro}`, dictionaries: [ claro ] },
  { name: BrandType.Beta, dictionaries: [ generalBeta ] },
  { name: BrandType.Jcap, dictionaries: [ generalJcap ] },
  { name: BrandType.Apex, dictionaries: [ generalApex ] },
  { name: BrandType.Pra, dictionaries: [ generalPra ] },
];
export default dictionaries;
